import SEO from '../components/SEO';

function About() {
  return (
    <div className="page-about">
      <SEO title="About Us" description="Learn about Anthroper, our mission to keep you informed with fresh articles and free online tools." path="/about" />
      <div className="container content-page">
        <h1>About Anthroper</h1>
        <section>
          <h2>Our Mission</h2>
          <p>Anthroper was built to solve a simple problem: most online tools are slow, full of ads, and want your email before you can do anything. And most news sites bury their content behind pop-ups and clickbait. We built something better — clear articles and instant tools that respect your time and your privacy.</p>
        </section>
        <section>
          <h2>What Makes Us Different</h2>
          <p>Every tool on Anthroper processes your data entirely in your browser. Nothing is ever sent to a server. Your text, your JSON, your passwords — they stay on your device, period. No accounts, no tracking, no premium tiers.</p>
          <p>Our articles skip the fluff. We cover tech, business, and security with clear analysis that gets to the point.</p>
        </section>
        <section>
          <h2>Who Is This For?</h2>
          <p>Everyone. Students, writers, marketers, designers, teachers, small business owners, and yes, developers too. Our tools are designed to be simple enough for anyone to use, while still being powerful enough for professionals.</p>
        </section>
        <section>
          <h2>Free Forever</h2>
          <p>Anthroper is free to use with no limits, no sign-up walls, and no premium tiers. We keep the lights on through non-intrusive advertising that does not interfere with your experience.</p>
        </section>
        <section>
          <h2>Get in Touch</h2>
          <p>Have feedback or a feature request? Visit our <a href="/contact">Contact page</a> to reach out. We read every message.</p>
        </section>
      </div>
    </div>
  );
}

export default About;
